<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="pvi"></a> Copyright © 1996 by Laura Kasischke<br/>
All rights reserved</p>
<p class="timebreak"> <br/></p>
<p class="center">For information about permission to reproduce selections from this book, write to Permissions, Houghton Mifflin Harcourt Publishing Company, 215 Park Avenue South, New York, New York 10003.</p>
<p class="timebreak"> <br/></p>
<p class="center"><a href="http://www.hmhco.com/popular-reading" target="_blank">www.hmhco.com</a></p>
<p class="timebreak"> <br/></p>
<p class="center">The Library of Congress has cataloged the print edition as follows:<br/>
Kasischke, Laura, date.</p>
<p class="center">Suspicious river / Laura Kasischke.<br/>
<span style="font-size: smaller">ISBN</span> 0-395-77397-0<br/>
<span style="font-size: smaller">ISBN</span> 0-395-86002-4 (pbk.)<br/>
I. Title</p>
<p class="center"><span style="font-size: smaller">PS</span>3561.<span style="font-size: smaller">A</span>6993<span style="font-size: smaller">S</span>87 1996 95-46801<br/>
813'.54—dc20 CIP</p>
<p class="timebreak"> <br/></p>
<p class="center">e<span style="font-size: smaller">ISBN</span> 978-0-544-46493-3<br/>
v1.0614</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?258c5d2c